import { render, staticRenderFns } from "./PopoverBankDetails.vue?vue&type=template&id=280da1be"
import script from "./PopoverBankDetails.vue?vue&type=script&lang=js"
export * from "./PopoverBankDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports